import type { LearnPostResponse, LearnTranslations } from '@/api/types';
import type { Lang } from '@/types';

/**
 * Tanlangan tildagi matn, bo'lmasa o'zbekcha. Prerender va hydration doim uz da (i18n),
 * shuning uchun tarjima faqat hydration'dan keyin almashadi — HTML mos keladi.
 */
export function pickLang(lang: Lang, uz: string, ru?: string | null, en?: string | null): string {
  const tr = lang === 'ru' ? ru : lang === 'en' ? en : null;
  return tr?.trim() ? tr : uz;
}

/** Post shu tilda bormi (uz — doim). Tarjima yaxlit (V55 CHECK) — sarlavha belgi bo'la oladi. */
export function hasTranslation(p: LearnTranslations, lang: Lang): boolean {
  if (lang === 'uz') return true;
  return Boolean((lang === 'ru' ? p.titleRu : p.titleEn)?.trim());
}

/** Kartochka va havolalar uchun sarlavha + tavsif */
export function localizedSummary(p: LearnTranslations & { title: string; summary: string }, lang: Lang) {
  const translated = hasTranslation(p, lang);
  return {
    title: translated ? pickLang(lang, p.title, p.titleRu, p.titleEn) : p.title,
    summary: translated ? pickLang(lang, p.summary, p.summaryRu, p.summaryEn) : p.summary,
    translated,
  };
}

/**
 * Darslik sahifasi: sarlavha, tavsif va matn bitta tildan olinadi (aralashmasin).
 * contentLang — matn haqiqatda qaysi tilda (`lang` atributi uchun).
 */
export function localizedPost(p: LearnPostResponse, lang: Lang) {
  const translated = hasTranslation(p, lang);
  const contentLang: Lang = translated ? lang : 'uz';
  const contentMd =
    contentLang === 'ru' ? p.contentMdRu : contentLang === 'en' ? p.contentMdEn : p.contentMd;
  return {
    ...localizedSummary(p, lang),
    contentMd: contentMd ?? null,
    contentLang,
  };
}
